module.exports = __webpack_public_path__ + "static/media/sundaram_svg.4708c73b.svg";